import React from "react";
import { useNavigate } from "react-router-dom";
import "../uploadProducts.css";

export default function EbayUploadLanding() {
    const navigate = useNavigate();

    return (
        <div className="upload-choice-grid">
            <button
                type="button"
                className="upload-choice-tile"
                onClick={() => navigate("/upload-inventory/new-ebay-listing")}
            >
                <p className="upload-choice-eyebrow">eBay</p>
                <h3 className="upload-choice-title">New Product Listing</h3>
                <p className="upload-choice-copy">
                    Create a single or variant listing from a product SKU.
                </p>
            </button>
            <button
                type="button"
                className="upload-choice-tile"
                disabled
                title="Coming soon"
            >
                <p className="upload-choice-eyebrow">eBay</p>
                <h3 className="upload-choice-title">Update Existing Listing</h3>
                <p className="upload-choice-copy">
                    Refresh price or details on an existing eBay offer.
                </p>
            </button>
        </div>
    );
}
